module.exports = __webpack_public_path__ + "static/design-73aa74f45a8e836a40f3247c1b1561e9.png";